import { Modal } from '@mantine/core';

import classNames from './modal.module.css';

export const ModalOverride = Modal.extend({ classNames });
